module.exports = __webpack_public_path__ + "img/drug-14.f702261a.png";